// CSRF token of the current Web session, kept in memory only (never in browser
// storage). AuthProvider sets it after sign-in / session restore and clears it
// on sign-out; state-changing API calls send it as X-CSRF-Token.
let csrf: string | null = null;
export const setCsrf = (token: string | null) => { csrf = token; };
export const getCsrf = () => csrf;
